import {createActionObject} from "../../redux/utils";
import $ from "jquery";

const createActions = ({
    actions: {
        ENABLED_SET,
        MINIMAL_VALUE_SET,
        USER_EXCEPTION_TYPE_SET,
        EXCEPTION_USERS_SET,
    },
    getStateSelector,
    onChangeEvent
}) => {
    const createOnChangedAction = (type) => {
        return val => (dispatch, getState) => {
            dispatch(createActionObject(type, val))
            $(document).trigger(onChangeEvent, [getStateSelector(getState())])
        }
    }

    const setEnabled = createOnChangedAction(ENABLED_SET)
    const setMinimalValue = createOnChangedAction(MINIMAL_VALUE_SET)
    const setUserExceptionType = createOnChangedAction(USER_EXCEPTION_TYPE_SET)
    const setExceptionUsers = createOnChangedAction(EXCEPTION_USERS_SET)
    return {
        setEnabled,
        setMinimalValue,
        setUserExceptionType,
        setExceptionUsers,
    }
}

export default createActions


// WEBPACK FOOTER //
// ./web/js/administration/lowBalanceSettings/actionsGenerator.js